import { createApp } from "vue";
import SearchAllEvents from "./SearchAllEvents.vue";

createApp(SearchAllEvents).mount("#search-app-all-events");
